import styles from './styles.module.scss';
import Image from 'next/image';

const NavigationBar = ({ slides, activeIndex, onNavClick }) => {
    const handlePrev = () => {
        const newIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
        onNavClick(newIndex);
    };

    const handleNext = () => {
        const newIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
        onNavClick(newIndex);
    };

    const renderTabs = () => {
        return slides?.map((slide, index) => {
            const { title } = slide?.heroSlide;
            return (
                <button 
                    key={index}  
                    className={`${styles.navBar__tab} ${index === activeIndex ? 'active' : ''}`} 
                    onClick={() => onNavClick(index)}
                >
                    <span>
                        {title}
                    </span>
                </button>
            );
        });
    };

    return (
        <div className={styles.navBar}>
            <Image 
                src={'/hero_tab_start.png'}
                width={62}
                height={44}
                alt="Start Navigation"
            />
            <button className={styles.navBar__mobileButton} onClick={handlePrev}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M14 17L9 12L14 7V17Z" fill="#F6F6F6"/>
                </svg>
            </button>
            <div className={styles.navBar__tabs}>
                {renderTabs()}
            </div>
            <button className={styles.navBar__mobileButton} onClick={handleNext}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10 17L15 12L10 7V17Z" fill="#F6F6F6"/>
                </svg>
            </button>
            <Image 
                src={'/hero_tab_end.png'}
                width={62}
                height={44}
                alt="End Navigation"
            />
        </div>
    );
};

export default NavigationBar;
